import { useToken } from '@hub/design-system-base';
import { H3 } from '@hub/heading';
import { Imposter } from '@hub/imposter';
import { LinkBox, LinkOverlay } from '@hub/link';
import React from 'react';
import trackClickEvents, { categories } from '../analytics/trackEvents';
import { CloudinaryImage, IMAGE_SIZES_TILE_PRIMARY, IMAGE_SIZES_TILE_SECONDARY } from '../cloudinary-image';
import { jsx as _jsx } from "react/jsx-runtime";
export const CategoryTile = _ref => {
  let {
    sx,
    title,
    image,
    callToAction,
    as
  } = _ref;
  const [sizeMd, sizeHalf] = useToken('sizes', ['size-md', 'size-half']);
  const primaryOrderPosition = 2;
  const isPrimary = Array.isArray(sx === null || sx === void 0 ? void 0 : sx.order) && (sx === null || sx === void 0 ? void 0 : sx.order[1]) === primaryOrderPosition;
  return /*#__PURE__*/_jsx(LinkBox, {
    sx: sx,
    onClick: () => trackClickEvents.clicked(categories.CATEGORY_DECK, "Top Category | ".concat(title)),
    "data-id": "category-spotlight_category-tile_CategoryTile_LinkBox",
    children: /*#__PURE__*/_jsx(Imposter, {
      as: as,
      sx: sx,
      impose: /*#__PURE__*/_jsx(H3, {
        color: "white",
        align: "center",
        sx: {
          width: 'size-full',
          height: 'size-full',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          paddingBottom: 'spacing-sm',
          '&::before': {
            content: "''",
            display: 'block',
            position: 'absolute',
            bottom: 0,
            backgroundImage: 'linear-gradient(-180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.53) 100%)',
            height: "min(".concat(sizeMd, ", ").concat(sizeHalf, ")"),
            width: 'size-full'
          }
        },
        "data-id": "category-spotlight_category-tile_CategoryTile_H3",
        children: /*#__PURE__*/_jsx(LinkOverlay, {
          href: callToAction.url,
          sx: {
            zIndex: 'elevatedContent',
            paddingX: 'spacing-xs'
          },
          "data-id": "category-spotlight_category-tile_CategoryTile_H3_LinkOverlay",
          children: title
        })
      }),
      position: "center",
      "data-id": "category-spotlight_category-tile_CategoryTile_LinkBox_Imposter",
      children: /*#__PURE__*/_jsx(CloudinaryImage, {
        ratio: "1",
        imageSetOrImage: image,
        sizes: isPrimary ? IMAGE_SIZES_TILE_PRIMARY : IMAGE_SIZES_TILE_SECONDARY,
        "data-id": "category-spotlight_category-tile_CategoryTile_Imposter_CloudinaryImage"
      })
    })
  });
};